import remoteServices from '~/constants/RemoteServices';

export const BULK_ORDER_QUANTITY_THRESHOLD = 5;
export const DEFAULT_QUOTE_QUANTITY = 25;
export const HIGH_COLOR_THRESHOLD = 5;
export const HIGH_COLOR_MIN_QTY = 48;
export const INTL_BULK_INCREMENT_PERCENTAGE = 10;
export const INTL_SINGLES_INCREMENT_PERCENTAGE = 25;
export const MIN_VOLUME_DISCOUNT_PERCENTAGE = 0.1;
export const SINGLES_THRESHOLD = 6;

export const PRICE_TIPS_MODE = {
  DEFAULT: 'default',
  DROP_ONE_VIEW: 'drop_one_view',
  DROP_ONE_COLOR: 'drop_one_color',
  DROP_SLEEVE_VIEW: 'drop_sleeve_view',
  EMBROIDERY_TO_PRINT: 'embroidery_to_print'
};

export const QUOTE_SERVICE_CAVEATS = {
  TEMPORARY: 'temporary_price_change_pandemic',
  PRICE_CHANGE: 'price_change'
};

export const MODES = {
  GET_QUOTE: 0,
  BUY_NOW: 1,
  SUMMARY_LINK: 2,
  UPDATE_QUANTITIES: 3,
  THREE_WAYS_TO_BUY: 4,
  REAL_TIME_PRICE: 5,
  REAL_TIME_PRICE_SUMMARY: 6,
  MONEY_SAVING_TIPS: 7,
  SHIPPING_FORM: 8
};

export const STATES = {
  QUOTE_FORM: 0,
  SHIPPING_FORM: 1,
  WCIBMO: 2,
  MONEY_SAVING_TIPS: 3,
  IMPOSSIBLE_TO_QUOTE: 4,
  MULTI_ITEM_SUMMARY: 5,
  LOADING: 7,
  MMS_ERROR: 8
};

export const WCIBMOS = {
  QUOTE_SERVICE_ERROR: 'quote_service_error',
  SIZES_NOT_AVAILABLE: 'sizes_not_available',
  INVALID_ZIP: 'invalid_shipping_postal_code',
  CANADA_TO_US: 'canada_product_to_us',
  US_TO_CANADA: 'us_product_to_canada',
  RAISE_QTY: 'raise_quantity_above_minimum',
  RAISE_QTY_CHANGE_PRODUCT:
    'raise_quantity_above_minimum_or_change_to_alternate_product',
  RAISE_QTY_CHANGE_STYLE:
    'raise_quantity_above_minimum_or_change_to_alternate_style',
  RAISE_QTY_CHANGE_TO_ALTERNATE:
    'raise_quantity_above_minimum_or_change_to_alternate',
  RAISE_QTY_ABOVE_HI_COLOR_MIN: 'raise_quantity_above_high_color_min',
  RAISE_QTY_ABOVE_HI_CHANGE_PRODUCT:
    'raise_quantity_above_high_color_min_or_change_to_alternate_product',
  RAISE_QTY_ABOVE_HI_CHANGE_STYLE:
    'raise_quantity_above_high_color_min_or_change_to_alternate_style',
  RAISE_QTY_ABOVE_HI_CHANGE_TO_ALTERNATE:
    'raise_quantity_above_high_color_min_or_change_to_alternate',
  RAISE_QTY_ABOVE_HI_REMOVE_SLEEVE:
    'raise_quantity_above_high_color_min_or_remove_sleeve',
  RAISE_QTY_REMOVE_SLEEVE: 'raise_quantity_above_minimum_or_remove_sleeve',
  REMOVE_NAMES_AND_NUMBERS: 'remove_names_and_numbers',
  RAISE_QTY_COLOR_MATCH: 'ink_match_minimum_not_met',
  ENTER_QUANTITIES: 'enter_quantities'
};

export const CATEGORY_IDS = {
  US: 4,
  KOOZIES: 42,
  PERFORMANCE: 47
};

// more may be added later
export const STATE_TO_ANALYTICS_LOCATION = {
  [STATES.QUOTE_FORM]: 'lab_quote_form',
  [STATES.SHIPPING_FORM]: 'lab_quote_zip'
};

export const STYLE_IDS = {
  FULL_COLOR_KOOZIE: 166800,
  GILDAN_100_COTTON: 4100,
  GILDAN_SOFTSTYLE: 176100
};

export const URLS = {
  quoting: `${remoteServices.pricing}/quote_widget`,
  mms: `${remoteServices.products}/api/out`,
  CANADA: 'canada-products/64',
  NO_MINIMUM: 'no-minimum/96',
  SIZE_SURCHARGES: `${remoteServices.pricing}/size_surcharges`
};

// quote_service/config/locales/en.yml
export const ERRORS = {
  INK_MATCH_MINIMUM_NOT_MET: 26
};
